
import { mapState } from 'vuex'
import ContactUs from '@/components/ui/ContactUs.vue'
import ContactUsChatbase from '@/components/ui/ContactUsChatbase.vue'

export default {
  components: {
    ContactUsChatbase,
    ContactUs
  },

  computed: {
    ...mapState('customer', {
      isMerchant: state => typeof state.merchant?.merchantId === 'number'
    }),

    showChatbase () {
      if (this.isMerchant) {
        return false
      }
      return true
    }
  }

}
